'use strict'

module.exports = json
json.displayName = 'json'
json.aliases = ['jsonp']
function json(Prism) {
  Prism.languages.json = {
    property: /"(?:\\.|[^\\"\r\n])*"(?=\s*:)/i,
    string: {
      pattern: /"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
      greedy: true
    },
    number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee][+-]?\d+)?/,
    punctuation: /[{}[\]);,]/,
    operator: /:/g,
    boolean: /\b(?:true|false)\b/i,
    null: /\bnull\b/i
  }
  Prism.languages.jsonp = Prism.languages.json
}



//////////////////
// WEBPACK FOOTER
// ./~/refractor/lang/json.js
// module id = 325
// module chunks = 29546219236060 61549186969478 213534597649335